/* eslint-disable */
<template>
  <article>
    <div class="image-view hidden">
      <svg class="controls-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
        <path d="M46.663,27.62l-3.457-3.457L26.663,40.707,10.12,24.163,6.663,27.62,23.207,44.164,6.664,60.706l3.457,3.457L26.663,47.62,43.206,64.163l3.457-3.457L30.12,44.164Z" transform="translate(-6.663 -24.163)" fill="#fff"/>
      </svg>
      <svg class="controls controls-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 40">
        <path d="M139.14,8.16l-20.034,20-3.466-3.45L132.218,8.16,115.64-8.38l3.466-3.46Z" transform="translate(139.14 28.16) rotate(180)" fill="#fff"/>
      </svg>
      <svg class="controls controls-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 40">
        <path d="M139.14,8.16l-20.034,20-3.466-3.45L132.218,8.16,115.64-8.38l3.466-3.46Z" transform="translate(-115.64 11.84)" fill="#fff"/>
      </svg>
      <div class="progress"></div>
      <div class="image-viewport"></div>
    </div>
    <header class="main-header">
      <h1 v-html="title"></h1>
      <span v-if="isEvent">{{ address.street }} {{ address.housenumber }}, {{ address.city }}  &bull;  {{ getDate() }}</span>
      <span v-else v-html="resource"></span>
    </header>

    <div v-if="isEmbed && newsPostableType === 'Facebook'" class="news-item news-item-single">
      <div
        class="fb-post news-facebook"
        :data-href="newsPostable.data.source_url"
        data-width="auto"
        data-show-text="true"
      />
    </div>
    <div v-else class="news-item news-item-single">
      <p v-html="parseHtml(message)"></p>
      <div class="news-media" v-if="cover || media.data.length > 0">
        <div
            v-for="(media, i) in mediaByType('image')"
            :key="i"
            class="news-media-item"
            :style="`background-image: url(${media.media_url})`"
            @click="openImages(i)"
          />
      </div>
    </div>
  </article>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import Branche from '@/mixins/Branche'
import Distance from '@/mixins/Distance'
import Utilities from '@/mixins/Utilities'

export default {
  name: 'ec-article',
  mixins: [Branche, Distance, Utilities],
  props: {
    isEvent: {
      type: Boolean,
      default: false
    },
    address: {
      type: Object,
      default () {
        return {
          city: '',
          housenumber: '',
          postalcode: '',
          street: ''
        }
      }
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    published: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    },
    media: {
      type: Object,
      default () {
        return {
          data: []
        }
      }
    },
    newsPostable: {
      type: Object,
      default () {
        return {}
      }
    },
    newsPostableType: {
      type: String,
      default: ''
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isLoading: false,
      slides: null
    }
  },
  computed: {
    ...mapState([
      'eventLoader'
    ]),
    isEmbed () {
      if (_.isEmpty(this.newsPostable)) {
        return 0
      }
      return this.newsPostable.data.force_embed
    },
    resource () {
      if (!_.isEmpty(this.newsPostable)) {
        let url = '<a target="_blank" href="' + this.newsPostable.data.source_url + '">'
        let closingTag = '</a>'
        let source

        switch (this.newsPostableType) {
          case 'Custom':
            source = this.surrounding.name + ' - Enjoj'
            url = ''
            closingTag = ''
            break
          case 'DotNews':
            source = this.surrounding.name + ' - Nieuws.nl'
            break
          case 'RSS':
            source = 'RSS'
            url = ''
            closingTag = ''
            break
          case 'Facebook':
            source = 'Facebook'
            break
        }
        url += source + closingTag

        return url
      }
      return ''
    },
    startMoment () {
      return this.startDate
    },
    endMoment () {
      return this.endDate
    }
  },
  watch: {
    eventLoader (condition) {
      this.isLoading = condition
    },
    newsPostable (item) {
      this.renderImages(item.data.media.data)
    }
  },
  created () {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: '1055232427990398',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v4.0'
      })
      console.log(window.FB)
    }

    (function (d, s, id) {
      var js = d.getElementsByTagName(s)[0]
      var fjs = d.getElementsByTagName(s)[0]

      if (d.getElementById(id)) return
      js = d.createElement(s); js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v4.0'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  },
  mounted () {
    window.FB.XFBML.parse()

    const slides = {
      quantity: 0,
      imgArr: [],
      dom: {},
      isSliding: false,
      direction: '',
      currentImage: {},
      startX: null,
      dist: null,

      open (imgs, index) {
        this.dom.slide = document.querySelector('.image-view')
        this.dom.slide.classList.remove('hidden')
        this.dom.close = this.dom.slide.querySelector('.controls-close')
        this.dom.leftControl = this.dom.slide.querySelector('.controls-left')
        this.dom.rightControl = this.dom.slide.querySelector('.controls-right')
        this.dom.progressBar = this.dom.slide.querySelector('.progress')
        this.dom.viewport = this.dom.slide.querySelector('.image-viewport')
        // Events
        this.dom.leftControl.addEventListener('mousedown', this.backward.bind(this))
        this.dom.rightControl.addEventListener('mousedown', this.forward.bind(this))
        this.dom.progressBar.addEventListener('click', this.jumpToMarker.bind(this))
        this.dom.close.addEventListener('click', () => { this.close() })
        // init
        this.quantity = imgs.length
        this.build(imgs)

        this.dom.viewport.addEventListener('touchstart', e => {
          const touchobj = e.changedTouches[0]
          this.startX = parseInt(touchobj.clientX)
        }, false)
        this.dom.viewport.addEventListener('touchmove', e => {
          const touchobj = e.changedTouches[0]
          this.dist = parseInt(touchobj.clientX) - this.startX
          e.preventDefault()
        }, false)
        this.dom.viewport.addEventListener('touchend', e => {
          if (this.quantity > 1) {
            if (this.dist > 75) {
              this.backward(e)
            } else if (this.dist < -75) {
              this.forward(e)
            }
          }
          this.dist = 0
        }, false)

        if (this.quantity > 1 && index) {
          for (let i = 0; i < index; i++) {
            this.forward()
            this.updateProgressBar()
          }
        }
      },
      close () {
        this.dom.slide.classList.add('hidden')
        this.dom.progressBar.innerHTML = ''
      },
      build (imgs) {
        while (this.dom.viewport.firstChild) {
          this.dom.viewport.removeChild(this.dom.viewport.firstChild)
        }
        this.buildSlides(imgs)

        this.imgArr = []
        for (let i = 0; i < this.quantity; i++) {
          this.imgArr.push({ id: i, pos: i })
        }

        if (this.quantity === 1) {
          this.dom.leftControl.classList.add('hidden')
          this.dom.rightControl.classList.add('hidden')
          this.dom.progressBar.classList.add('hidden')
          return
        }
        this.dom.leftControl.classList.remove('hidden')
        this.dom.rightControl.classList.remove('hidden')
        this.dom.progressBar.classList.remove('hidden')

        while (this.dom.progressBar.firstChild) {
          this.dom.progressBar.removeChild(this.dom.progressBar.firstChild)
        }
        this.buildProgressBar()

        this.initialRender()
      },

      buildSlides (imageSlides) {
        let imageReel = ''
        imageSlides.forEach(el => {
          imageReel += `
            <div class="slide-wrapper">
              <img class="slide" src="${el}">
            </div>
          `
        })
        this.dom.viewport.insertAdjacentHTML('beforeend', imageReel)
        this.dom.images = [...document.querySelectorAll('.slide-wrapper')]
      },

      buildProgressBar () {
        const progressMarker = '<div class="progress-marker"></div>'
        let progressBarString = ''
        for (let i = 0; i < this.quantity; i++) {
          progressBarString += progressMarker
        }
        this.dom.progressBar.insertAdjacentHTML('beforeend', progressBarString)

        this.dom.progressMarkers = [...document.querySelectorAll('.progress-marker')]
      },

      updateProgressBar () {
        if (this.currentMarker) {
          this.currentMarker.classList.remove('progress-marker-active')
        }

        this.currentMarker = this.dom.progressMarkers[this.imgArr[1].id]
        this.currentMarker.classList.add('progress-marker-active')
      },

      initialRender () {
        this.imgArr.forEach(el => {
          el.pos === this.quantity - 1 ? el.pos = 0 : el.pos += 1
        })

        this.sortImageArray()

        this.dom.images[this.imgArr[0].id].classList.add('prev')
        this.dom.images[this.imgArr[0].id].classList.add('hide')

        if (this.quantity > 2) {
          for (let i = 2; i < this.quantity; i++) {
            this.dom.images[this.imgArr[i].id].classList.add('hide')
            this.dom.images[this.imgArr[i].id].classList.add('queue')
          }
        }
        this.updateProgressBar()
      },

      jumpToMarker (e) {
        let jumpAmount
        // eslint-disable-next-line
        let jumpInterval
        let jumpTicker = 1
        if (e.target.classList.contains('progress-marker')) {
          this.dom.images.forEach(el => el.classList.add('slide-wrapper--jumper'))

          jumpAmount = this.dom.progressMarkers.indexOf(e.target) - this.dom.progressMarkers.indexOf(this.currentMarker)

          if (jumpAmount > 0) {
            this.forward(e)
            jumpInterval = setInterval(function () {
              if (jumpTicker === jumpAmount) {
                clearInterval(jumpInterval)
                this.dom.images.forEach(el => el.classList.remove('slide-wrapper--jumper'))
                return
              }
              this.forward(e)
              jumpTicker++
            }.bind(this), 75)
          } else {
            jumpAmount = jumpAmount * -1
            this.backward(e)
            jumpInterval = setInterval(function () {
              if (jumpTicker === jumpAmount) {
                clearInterval(jumpInterval)
                this.dom.images.forEach(el => el.classList.remove('slide-wrapper--jumper'))
                return
              }
              this.backward(e)
              jumpTicker++
            }.bind(this), 75)
          }
        }
      },

      backwardRender () {
        if (this.quantity === 2) {
          this.dom.images[this.imgArr[1].id].classList.remove('queue')
          this.dom.images[this.imgArr[1].id].classList.add('prev')
          this.dom.images[this.imgArr[0].id].classList.add('queue')

          setTimeout(function () {
            this.dom.images[this.imgArr[1].id].classList.remove('hide')
            this.dom.images[this.imgArr[1].id].classList.remove('prev')
          }.bind(this), 1)
        } else {
          this.dom.images[this.imgArr[0].id].classList.add('hide')
          this.dom.images[this.imgArr[0].id].classList.add('prev')

          this.dom.images[this.imgArr[0].id].classList.remove('queue')
          this.dom.images[this.imgArr[1].id].classList.remove('hide')
          this.dom.images[this.imgArr[1].id].classList.remove('prev')
          this.dom.images[this.imgArr[2].id].classList.add('queue')
        }
      },

      forwardRender () {
        if (this.quantity === 2) {
          this.dom.images[this.imgArr[0].id].classList.add('prev')
          this.dom.images[this.imgArr[1].id].classList.remove('prev')
          this.dom.images[this.imgArr[1].id].classList.add('queue')

          setTimeout(function () {
            this.dom.images[this.imgArr[1].id].classList.remove('hide')
            this.dom.images[this.imgArr[1].id].classList.remove('queue')
          }.bind(this), 1)
        } else {
          this.dom.images[this.imgArr[0].id].classList.add('prev')
          this.dom.images[this.imgArr[1].id].classList.remove('hide')
          this.dom.images[this.imgArr[1].id].classList.remove('queue')
          this.dom.images[this.imgArr[this.quantity - 1].id].classList.add('hide')
          this.dom.images[this.imgArr[this.quantity - 1].id].classList.add('queue')
          this.dom.images[this.imgArr[this.quantity - 1].id].classList.remove('prev')
        }
      },

      backward (e) {
        if (!e.target.classList.contains('progress-marker')) {
          e.preventDefault()
          if (this.isSliding) return
          this.isSliding = true
          this.direction = 'backward'
        }

        this.currentImage = this.dom.images[this.imgArr[1].id]
        this.boundSliderTransitionend = this.sliderTransitionend.bind(this)
        this.currentImage.addEventListener('transitionend', this.boundSliderTransitionend)

        this.imgArr.forEach((el) => {
          el.pos === this.quantity - 1 ? el.pos = 0 : el.pos += 1
        })
        this.sortImageArray()
        this.backwardRender()
      },

      forward (e) {
        if (e) {
          if (!e.target.classList.contains('progress-marker')) {
            e.preventDefault()
            if (this.isSliding) { return }
            this.isSliding = true
            this.direction = 'forward'
          }
        }

        this.currentImage = this.dom.images[this.imgArr[1].id]
        this.boundSliderTransitionend = this.sliderTransitionend.bind(this)
        this.currentImage.addEventListener('transitionend', this.boundSliderTransitionend)

        this.imgArr.forEach((el) => {
          el.pos === 0 ? el.pos = this.quantity - 1 : el.pos -= 1
        })
        this.sortImageArray()
        this.forwardRender()
      },

      sliderTransitionend () {
        this.isSliding = false
        if (this.quantity === 2 && this.direction === 'backward') {
          this.dom.images[this.imgArr[0].id].classList.add('hide')
          this.dom.images[this.imgArr[0].id].classList.remove('queue')
          this.dom.images[this.imgArr[0].id].classList.add('prev')
        }
        if (this.quantity === 2 && this.direction === 'forward') {
          this.dom.images[this.imgArr[0].id].classList.add('hide')
          this.dom.images[this.imgArr[0].id].classList.remove('prev')
          this.dom.images[this.imgArr[0].id].classList.add('queue')
        }
        this.updateProgressBar()
        this.currentImage.removeEventListener('transitionend', this.boundSliderTransitionend)
      },

      sortImageArray () {
        this.imgArr.sort(compare)
        function compare (a, b) {
          if (a.pos < b.pos) return -1
          if (a.pos > b.pos) return 1
          return 0
        }
      }
    }

    this.slides = slides
  },
  methods: {
    getDate () {
      moment.locale('nl')
      if (this.published) {
        let published = moment(this.published, 'YYYY-MM-DD hh:mm:ss').format('LLL')

        return published
      } else if (this.isEvent) {
        let startDate = moment(this.startDate, 'YYYY-MM-DD hh:mm:ss').format('LL')
        let startTime = moment(this.startDate, 'YYYY-MM-DD hh:mm:ss').format('HH:mm')

        let endDate = moment(this.endDate, 'YYYY-MM-DD hh:mm:ss').format('LL')
        let endTime = moment(this.endDate, 'YYYY-MM-DD hh:mm:ss').format('HH:mm')
        let time = startDate + ' - ' + startTime + ' | ' + endDate + ' - ' + endTime

        if (startDate === endDate) {
          time = startTime + ' - ' + endTime
          return startDate + ' | ' + time
        }

        return time
      }
      return ''
    },
    visibilityChanged (isVisible, entry, element) {
      console.log(element)
    },
    parseHtml (message) {
      message = message.replace(/href=" /g, 'href="')

      message = this.urlify(message)

      let wrapper = document.createElement('p')
      wrapper.innerHTML = message

      if (this.newsPostableType === 'DotNews') {
        let paragraphs = wrapper.querySelectorAll('p')
        for (let i = 0; i < paragraphs.length; i++) {
          if (paragraphs[i].innerHTML === '<br>') {
            paragraphs[i].classList.add('d-none')
          }
        }
      }

      return wrapper.innerHTML
    },
    urlify (text) {
      text = text.replace(/href="www/g, 'href="http://www')
      let newText = (text || '').replace(/\S+[a-z0-9]@[a-z0-9.]+/, match => {
        let email = match
        return '<a href="mailto:' + email + '">' + email + '</a>'
      })

      return (newText || '').replace(
        /([^\S]|[(]|^)(((https?:\/\/)|(www\.))(\S+))/gi,
        (match, space, url) => {
          let hyperlink = url
            .replace(').', '')
            .replace(')', '')
            .replace('(', '')
          if (!hyperlink.match('^https?://')) {
            hyperlink = 'http://' + hyperlink
          }
          return (
            space +
            '<a target="_blank" href="' +
            hyperlink +
            '">' +
            url +
            '</a>'
          )
        }
      )
    },
    mediaByType (type) {
      let data = []
      if (this.media) {
        const media = this.media.data
        data = media.filter(item => item.type === type)
      }
      if (type === 'image' && this.cover) {
        data.unshift({ media_url: this.cover })
      }
      return data
    },
    openImages (index) {
      let images = []
      this.mediaByType('image').forEach(image => {
        images.push(image.media_url)
      })
      this.slides.open(images, index)
    }
  }
}
</script>
